webpackJsonp([23851501821332],{

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_Component) {
	    _inherits(ContactPage, _Component);
	
	    function ContactPage(props) {
	        _classCallCheck(this, ContactPage);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.validate = _this.validate.bind(_this);
	        _this.validateItem = _this.validateItem.bind(_this);
	        return _this;
	    }
	
	    ContactPage.prototype.validate = function validate(event) {
	        try {
	            if (!this.validateItem(event, 'first_name', 'Please enter First Name')) {
	                return;
	            }
	
	            if (!this.validateItem(event, 'last_name', 'Please enter Last Name')) {
	                return;
	            }
	
	            if (!this.validateItem(event, 'email', 'Please enter Email')) {
	                return;
	            }
	
	            if (!this.validateItem(event, 'phone', 'Please enter Phone')) {
	                return;
	            }
	        } catch (err) {
	            console.error(err);
	            event.preventDefault();
	        }
	    };
	
	    ContactPage.prototype.validateItem = function validateItem(event, id, msg) {
	        var elm = document.getElementById(id);
	        if (elm.value == '') {
	            var errorElm = document.getElementsByClassName('error-message')[0];
	            errorElm.innerHTML = msg;
	            elm.focus();
	            event.preventDefault();
	            return false;
	        }
	
	        return true;
	    };
	
	    ContactPage.prototype.render = function render() {
	        /*
	                    <!--
	                    <h2>
	                        Office
	                    </h2>
	                    <div className="address">
	                        <p>4900 Hopyard Rd</p>
	                        <p>Pleasanton CA</p>
	                    </div>
	                    -->
	         */
	        return _react2.default.createElement(
	            'div',
	            { className: 'contact-container' },
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Datasert - Contact Us' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'content' },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Email'
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:support@datasert.com' },
	                    'support@datasert.com'
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Address'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    '4900 Hopyard Road #100'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    'Pleasanton CA 94588'
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Phone'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    '973-752-5049'
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Have us reach you'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'contact-form' },
	                    _react2.default.createElement(
	                        'form',
	                        { className: 'contact-form2', action: 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8', method: 'POST', onSubmit: this.validate },
	                        _react2.default.createElement('input', { type: 'hidden', name: 'oid', value: '00Df4000001Qt1b' }),
	                        _react2.default.createElement('input', { type: 'hidden', name: 'retURL', value: 'https://www.datasert.com/company/contact-thankyou' }),
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'first_name' },
	                            'First Name ',
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'required-dot' },
	                                '*'
	                            )
	                        ),
	                        _react2.default.createElement('input', { id: 'first_name', maxLength: '40', name: 'first_name', size: '20', type: 'text' }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'last_name' },
	                            'Last Name ',
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'required-dot' },
	                                '*'
	                            )
	                        ),
	                        _react2.default.createElement('input', { id: 'last_name', maxLength: '80', name: 'last_name', size: '20', type: 'text' }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'email' },
	                            'Email ',
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'required-dot' },
	                                '*'
	                            )
	                        ),
	                        _react2.default.createElement('input', { id: 'email', maxLength: '80', name: 'email', size: '20', type: 'text' }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'phone' },
	                            'Phone ',
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'required-dot' },
	                                '*'
	                            )
	                        ),
	                        _react2.default.createElement('input', { id: 'phone', maxLength: '40', name: 'phone', size: '20', type: 'text' }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'company' },
	                            'Company'
	                        ),
	                        _react2.default.createElement('input', { id: 'company', maxLength: '40', name: 'company', size: '20', type: 'text' }),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('p', { className: 'error-message' }),
	                        _react2.default.createElement('input', { className: 'button-download-product', type: 'submit', name: 'submit' })
	                    )
	                )
	            )
	        );
	    };
	
	    return ContactPage;
	}(_react.Component);
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-company-contact-jsx-05edc278dbd6ca41dd5e.js